const messages = {
    pageTitle: 'Prace ręczne',
    menuTitle: 'Prace ręczne',

    filters: {
        search: 'Szukaj po nazwie'
    },

    table: {
        headers: {
            description: 'Opis czynności',
            efficiency: 'Wydajność [szt./h]',
            wasteAmount: 'Zepsucia na przyrząd [szt.]',
            wastePercent: 'Zepsucia na bieg [%]',
            isActive: 'Aktywna',
            actions: 'Usuń'
        }
    },

    actions: {
        addRow: 'Dodaj kolejną konfigurację'
    },

    unsavedChanges: {
        title: 'Niezapisane zmiany',
        message: 'Masz niezapisane zmiany. Czy chcesz je porzucić?',
        stay: 'Pozostań na ekranie',
        discard: 'Porzuć zmiany'
    },

    validation: {
        descriptionRequired: 'Proszę podać opis czynności.',
        efficiencyRequired: 'Proszę podać wydajność na godzinę.',
        wasteAmountRequired: 'Proszę podać zepsucia na przyrząd.',
        wastePercentRequired: 'Proszę podać zepsucia na bieg.',
        wastePercentRange: 'Wartość musi mieścić się w zakresie od 0 do 100.'
    },

    notifications: {
        saved: 'Konfiguracja prac ręcznych została zapisana.'
    },

    errors: {
        fetch: 'Nie udało się pobrać konfiguracji prac ręcznych.',
        save: 'Zapis konfiguracji prac ręcznych nie powiódł się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
